
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindShaft14 as ObiWindShaft14Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-shaft-14.js';
 
 
 

 
 export const ObiWindShaft14 = createComponent({
   react: React,
   tagName: 'obi-wind-shaft-14',
   elementClass: ObiWindShaft14Element,
   events: {
     
   }
  });
 
 